import { action } from 'satcheljs';

export const onLoadingChanged = action('onLoadingChanged', (loading: boolean) => ({ loading }));
export const onLoadingSetting = action('onLoadingSetting', (waiting: boolean) => ({ waiting }));
export const onLoadingWaiting = action('onLoadingWaiting', (waiting: boolean) => ({ waiting }));
